import React from 'react';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import FormInputText from '../../../../../common/Forms/FormTextField';
import DropdownFormInput from '../../../../../common/Forms/DropdownForm';
import { useDispatch, useSelector } from 'react-redux';
import {
  setAddress,
  setCountyId,
  setOrgCity,
  setSascaRegion,
  setState,
  setZip,
} from '../../../../../../redux/organization/organizationTabs/addressAndContacts/addressAndContactsSlice';
import { setCity } from '../../../../../../redux/organization/organizationForm/organizationFormSlice';

const StreetAddress = (props) => {
  const dispatch = useDispatch();
  const { control, defaultValue, register, errors } = props;
  const organizationReferenceData = useSelector(
    (state) => state.organizationReferenceData
  );
  const { cityList, countyList } = organizationReferenceData;

  return (
    <>
      <Typography
        variant='h5'
        style={{ marginBottom: '-10px', marginTop: '7px' }}
      >
        Street Address :
      </Typography>
      <Grid container spacing={2} style={{ marginTop: '0px' }}>
        <Grid item xs={12} sm={3}>
          <FormInputText
            name='address'
            type='text'
            control={control}
            errors={!!errors.address}
            helperText={errors?.address?.message}
            label='Address'
            register={register('address', {
              onChange: (e) => dispatch(setAddress(e.target.value)),
            })}
          />
          <DropdownFormInput
            name='countyId'
            control={control}
            options={countyList}
            defaultId={defaultValue?.countyId}
            label='County'
            register={register('countyId', {
              onChange: (e) => dispatch(setCountyId(e.target.value)),
            })}
          />
        </Grid>
        <Grid item xs={12} sm={3}>
          <DropdownFormInput
            name='orgCity'
            control={control}
            options={cityList}
            defaultId={defaultValue?.orgCity}
            orgCity={true}
            label='City'
            register={register('orgCity', {
              onChange: (e) => {
                dispatch(setOrgCity(e.target.value));
                dispatch(setCity(e.target.value));
              },
            })}
          />
          <DropdownFormInput
            name='countyId'
            control={control}
            options={countyList}
            defaultId={defaultValue?.countyId}
            sascsRegion={true}
            disabled={true}
            label='SASCA Region'
          />
        </Grid>
        <Grid item xs={12} sm={3}>
          <FormInputText
            name='state'
            type='text'
            control={control}
            errors={!!errors.state}
            helperText={errors?.state?.message}
            label='State'
            register={register('state', {
              onChange: (e) => dispatch(setState(e.target.value)),
            })}
          />
        </Grid>
        <Grid item xs={12} sm={3}>
          <FormInputText
            name='zip'
            type='number'
            control={control}
            errors={!!errors.zip}
            helperText={errors?.zip?.message}
            label='Zip'
            register={register('zip', {
              onChange: (e) => dispatch(setZip(e.target.value)),
            })}
          />
        </Grid>
      </Grid>
    </>
  );
};

export default StreetAddress;
